import { render } from "./BuildingQuestions.vue?vue&type=template&id=b7a64718"
import script from "./BuildingQuestions.vue?vue&type=script&lang=js"
export * from "./BuildingQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__